import type { ButtonHTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/Utils";


const buttonProps = cva(
    "",
    {
        variants: {
            intent: {
                primary: "flex items-center justify-center whitespace-nowrap font-bold bg-brand-500 border border-brand-950 hover:bg-brand-700 text-surface-950 rounded-lg",
                secondary: "flex items-center justify-center whitespace-nowrap font-bold border-2 bg-surface-950 border-brand-500 text-surface-200 rounded-lg " +
                    "hover:bg-brand-500 hover:text-surface-950 hover:font-bold",
                inactive : "flex items-center justify-center whitespace-nowrap bg-surface-900 text-surface-500 font-bold text-sm cursor-not-allowed rounded-lg",
                ghost: "font-medium text-surface-300 hover:text-surface-50 py-0",
                icon: "text-surface-300 hover:text-surface-300/50 rounded-full",
                social: "bg-surface-900 border border-surface-800 font-medium text-surface-100 rounded-lg " +
                    "hover:bg-surface-800 transition-colors gap-2 p-3 text-sm",
                link: "font-medium text-[13px] text-brand-500 hover:text-surface-600 " +
                    "transition-colors underline-offset-4 hover:underline",
            },
            size: {
                xSmall: "text-sm px-4",
                small: "text-sm px-4",
                medium: "w-full text-sm sm:w-auto py-2.5 px-8",
                large: "w-full text-lg h-14",
            },
            hover: {
                true: "transition-all duration-200",
                false: "",
            },
            glow: {
                true: "shadow-lg shadow-brand-500/20",
            },
        },
        compoundVariants: [
            { intent: "icon", size: null, class: "h-8 w-8" },
            { intent: "icon", size: "small", hover: false, class: "h-4 w-4" },
            { hover: true, class: "hover:brightness-110 hover:scale-[1.02]" },
            { glow: true, class: "focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 focus:ring-offset-brand-500" },
        ],
        defaultVariants: {
            intent: "primary",
            size: "medium",
        },
    }
);

export interface ButtonProps
    extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonProps> {
}

export const Button = (props: ButtonProps) => {
    const {
        className,
        intent,
        size,
        hover,
        glow,
        ...rest
    } = props;

    const toCva = { intent, size, hover, glow };

    return (
        <button className={cn(buttonProps(toCva), className)} {...rest} />
    );
}



